import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PartnerAdvertisingPlatform} from '../../models/partner/partner-advertising-platform';

@Injectable({
  providedIn: 'root'
})
export class PartnerAdvertisingPlatformService extends AbstractModelService<PartnerAdvertisingPlatform> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/partner-advertising-platform', PartnerAdvertisingPlatform);
  }
}
